import { render, staticRenderFns } from "./Zuschusskonto.vue?vue&type=template&id=25c89d9c&"
import script from "./Zuschusskonto.vue?vue&type=script&lang=js&"
export * from "./Zuschusskonto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports